
























import { Component, Prop, Vue } from "vue-property-decorator";
import FunctionNode from "../nodes/FunctionNode";
import InterfaceView from "./InterfaceView.vue";

@Component({
    components: {
        InterfaceView,
        CodeEditor: () => import("./CodeEditor.vue")
    }
})
export default class CodeOption extends Vue {

    // TODO: Make interface list reactive

    @Prop()
    node!: FunctionNode;

    @Prop()
    value!: string;

    mounted() {
        this.node.events.addInterface.addListener(this, () => { this.$forceUpdate(); });
        this.node.events.removeInterface.addListener(this, () => { this.$forceUpdate(); });
    }

    addInput() {
        this.node.addInput("Input" + Object.keys(this.node.inputInterfaces).length);
    }

    addOutput() {
        this.node.addOutput("Output" + Object.keys(this.node.outputInterfaces).length);
    }

    remove(name: string) {
        this.node.removeInterface(name);
    }

    renameInput(from: string, to: string) {
        this.node.renameInterface(from, to);
    }

    renameOutput(from: string, to: string) {
        this.node.renameInterface(from, to);
    }

}
